<div class="relative">

  <img [src]="src" [alt]="alt" [class]="'rounded-md ' + customClass">


  <button *ngIf="enableZoom"
    class="absolute bottom-1 left-1 z-20 p-1 rounded-full bg-gray-800 hover:bg-gray-700 transition-all duration-200 flex items-center justify-center min-w-[24px] min-h-[24px] shadow-sm"
    (click)="openZoomDialog(zoomDialog)" aria-label="Zoom image" type="button">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-white" viewBox="0 0 20 20" fill="currentColor"
      aria-hidden="true">
      <path fill-rule="evenodd"
        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
        clip-rule="evenodd" />
      <path fill-rule="evenodd" d="M8 5a1 1 0 011 1v1h1a1 1 0 110 2H9v1a1 1 0 11-2 0V9H6a1 1 0 110-2h1V6a1 1 0 011-1z"
        clip-rule="evenodd" />
    </svg>
  </button>
</div>


<ng-template #zoomDialog>
  <div class="p-4 bg-white rounded-lg" role="dialog" aria-modal="true" aria-labelledby="dialog-title">
    <div class="flex justify-end mb-2">
      <button mat-icon-button mat-dialog-close class="text-gray-500 hover:text-gray-700" aria-label="Close dialog"
        type="button">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <div class="flex items-center justify-center">
      <img [src]="src" [alt]="alt" class="max-w-full max-h-[70vh] object-contain">
    </div>
  </div>
</ng-template>